import { createAction, props } from '@ngrx/store';
import { ErrorResponse, User, UserList } from '@core/models';
import { SubscriptionStateType } from '@store/subscription/subscription.reducer';
import { BasicTariffs } from '@data/enums';

export enum ESubscriptionActions {

  loadFollowings = '[Subscription] Load Followings',
  loadFollowingsSuccess = '[Subscription] Load Followings Success',
  loadFollowingsFailure = '[Subscription] Load Followings Failure',

  loadFollowers = '[Subscription] Load Followers',
  loadFollowersSuccess = '[Subscription] Load Followers Success',
  loadFollowersFailure = '[Subscription] Load Followers Failure',

  clearSubscriptionsData = '[Subscription] Clear Subscriptions',

  subscribe = '[Subscription] Subscribe',
  subscribeSuccess = '[Subscription] Subscribe Success',
  subscribeFailure = '[Subscription] Subscribe Failure',

  reSubscribe = '[Subscription] Resubscribe',
  reSubscribeSuccess = '[Subscription] Resubscribe Success',
  reSubscribeFailure = '[Subscription] Resubscribe Failure',
}

export const loadFollowings = createAction(
  ESubscriptionActions.loadFollowings,
  props<{ isExpired: boolean }>(),
);

export const loadFollowingsSuccess = createAction(
  ESubscriptionActions.loadFollowingsSuccess,
  props<{ data: UserList }>(),
);

export const loadFollowingsFailure = createAction(
  ESubscriptionActions.loadFollowingsFailure,
  props<{ error: ErrorResponse }>(),
);

export const loadFollowers = createAction(
  ESubscriptionActions.loadFollowers,
);

export const loadFollowersSuccess = createAction(
  ESubscriptionActions.loadFollowersSuccess,
  props<{ data: UserList }>(),
);

export const loadFollowersFailure = createAction(
  ESubscriptionActions.loadFollowersFailure,
  props<{ error: unknown }>(),
);


export const clearSubscriptionsData = createAction(
  ESubscriptionActions.clearSubscriptionsData,
);

export const subscribe = createAction(
  ESubscriptionActions.subscribe,
  props<{ userId: string }>(),
);

export const subscribeSuccess = createAction(
  ESubscriptionActions.subscribeSuccess,
  props<{ user: User }>(),
);

export const subscribeFailure = createAction(
  ESubscriptionActions.subscribeFailure,
  props<{ error: unknown }>(),
);

export const reSubscribe = createAction(
  ESubscriptionActions.reSubscribe,
  props<{ userId: string, from?: SubscriptionStateType }>(),
);

export const reSubscribeSuccess = createAction(
  ESubscriptionActions.reSubscribeSuccess,
  props<{ user: User, from?: SubscriptionStateType }>(),
);

export const reSubscribeFailure = createAction(
  ESubscriptionActions.reSubscribeFailure,
  props<{ error: unknown }>(),
);

export const subscriptionActions = {
  setBasicTariff: createAction(
    '[Subscription] Init Feed',
    props<{ tariff: BasicTariffs }>(),
  ),
};
